import { AuthUser } from "aws-amplify/auth"
import { openEditor } from "react-profile"
import Resizer from "react-image-file-resizer";

export type HandleProfileImageUploadParams = {
    file: File
    key: string
    user: AuthUser
    resetUploaderError: () => void
    hideFileUpload: () => void
}

export default class ImageUtils {
    public static readonly DEFAULT_PLACE_IMAGE_SIZE = 1024;
    public static readonly DEFAULT_PROFILE_IMAGE_SIZE = 512;

    public static handleProfileImageUpload = async (uploadParams: HandleProfileImageUploadParams) => {

        uploadParams.resetUploaderError()

        const fileExtenstion = uploadParams.file.name.split('.').pop()
        const newFilename = `${uploadParams.user.userId}.${fileExtenstion}`

        uploadParams.key = newFilename

        const file: File = uploadParams.file;

        const result = await openEditor({
            src: file,
            square: true
        })

        if (result.cancel || !result.done) {
            uploadParams.hideFileUpload()

            // This will prevent uploader from continue - no better way found!
            throw new Error("User canceled!")
        }

        const editedFileBlob = await result.editedImage?.getBlob();

        console.warn("Edited blob: ", editedFileBlob);


        if (editedFileBlob) {
            const editedFile = new File([editedFileBlob], file.name)

            // Normalize profile image to 512x512
            const resizedFileObject = await this.resizeImage(editedFile, ImageUtils.DEFAULT_PROFILE_IMAGE_SIZE, ImageUtils.DEFAULT_PROFILE_IMAGE_SIZE);

            if (resizedFileObject instanceof File) {
                uploadParams.file = resizedFileObject
            }

        }

        return uploadParams;
    }


    public static resizeImage = (file: Blob, forcedWidth: number, forcedHeight: number) =>
        new Promise<string | Blob | File | ProgressEvent<FileReader>>(resolve => {
            Resizer.imageFileResizer(
                file,
                // Max:
                forcedWidth,
                forcedHeight,
                'JPEG',
                90, // % qality
                0,
                uri => {
                    resolve(uri);
                },
                // 'base64'
                'file',
                // Min:
                forcedWidth,
                forcedHeight
            );
        });
}